import type { Program, ProgramLevel, ProgramSubject } from '@lms/shared/types';

type ProgramWithCurriculum = Program & { levels?: ProgramLevel[] };

export function getProgramSubjects(program: Program | undefined): ProgramSubject[] {
  const curriculum = program as ProgramWithCurriculum | undefined;
  return curriculum?.levels?.flatMap((level) =>
    level.stages?.flatMap((stage) => stage.subjects ?? []) ?? [],
  ) ?? [];
}

export function getQuestionTypeLabel(type: string): string {
  if (type === 'MULTIPLE_CHOICE') return 'Pilihan Ganda';
  if (type === 'TRUE_FALSE') return 'Benar / Salah';
  if (type === 'ESSAY') return 'Esai';
  return 'Jawaban Singkat';
}

export const multipleChoiceOptions = [
  { text: '', isCorrect: true, order: 1 },
  { text: '', isCorrect: false, order: 2 },
];

export const trueFalseOptions = [
  { text: 'Benar', isCorrect: true, order: 1 },
  { text: 'Salah', isCorrect: false, order: 2 },
];
